import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';
import CharityLegacySettingsSection from '../charity-legacy-settings-section';
import MetaPixelCreateForm from '../meta-pixel-create-form/MetaPixelCreateForm';
import PayPalMerchantStatus from '../paypal-merchant-status';
import { Button } from '../../../atoms/button/index.ts';

const CharityLegacySettings = function CharityLegacySettings({
    pixelId,
    pixelDomain,
    merchantStatus,
    legacyUrl,
    showPayPal,
    isPayPalSuspended,
}) {
    const dashboardUrl = `${legacyUrl}/Account/Dashboard`;
    const redirectToCharitySettings = () => {
        const settingsUrl = `${legacyUrl}/Account/Portal/CharityProfile`;
        window.location.href = settingsUrl;
    };

    return (
        <>
            <div className={styles['charity-legacy-settings-header']}>
                <a href={dashboardUrl} className={`button ${styles.back}`}>Back</a>
            </div>
            <div className={styles['charity-legacy-settings']}>
                <CharityLegacySettingsSection
                    header="Charity Details"
                    body={(
                        <p>
                            {'Update your charity name, charity logo, and other details here. If you want to update your BSB or account number, please contact '}
                            <a href="mailto:support@giveeasy.org" className={styles['support-email']}>support@giveeasy.org</a>
                        </p>
                    )}
                    action={
                        <Button appearance="primary" id="edit-charity-details" onClick={redirectToCharitySettings}>Edit Details</Button>
                    }
                />
                {showPayPal && (
                    <CharityLegacySettingsSection
                        header="Paypal Connection"
                        body={<p>Authorize GiveEasy to collect Paypal donations on your behalf.</p>}
                        action={(
                            <PayPalMerchantStatus
                                merchantStatus={merchantStatus}
                                isSuspended={isPayPalSuspended}
                            />
                        )}
                    />
                )}
                <CharityLegacySettingsSection
                    header="Facebook Pixel"
                    body={(
                        <p>Connect Facebook pixel to measure performance of Facebook advertising</p>
                    )}
                    action={(
                        <MetaPixelCreateForm
                            pixelId={pixelId}
                            domain={pixelDomain}
                        />
                    )}
                />
            </div>
        </>
    );
};

const CharityLegacySettingsView = function CharityLegacySettingsView({
    config,
}) {
    const {
        pixelId,
        pixelDomain,
        merchantStatus,
        legacyUrl,
        showPayPal,
        isPayPalSuspended,
    } = JSON.parse(config);

    return (
        <CharityLegacySettings
            pixelId={pixelId}
            pixelDomain={pixelDomain}
            merchantStatus={merchantStatus}
            legacyUrl={legacyUrl}
            showPayPal={showPayPal}
            isPayPalSuspended={isPayPalSuspended}
        />
    );
};

CharityLegacySettings.propTypes = {
    pixelId: PropTypes.string.isRequired,
    pixelDomain: PropTypes.string.isRequired,
    merchantStatus: PropTypes.number.isRequired,
    legacyUrl: PropTypes.string.isRequired,
    showPayPal: PropTypes.bool.isRequired,
    isPayPalSuspended: PropTypes.bool.isRequired,
};

CharityLegacySettingsView.propTypes = {
    config: PropTypes.string.isRequired,
};

export default CharityLegacySettingsView;
